import React from "react";
import { Link } from "react-router-dom";
import "./MainBtn.css";

function MainBtn({
  button,
  isLight,
  onClick,
  type,
  link,
  handleClose,
  handleSend,
  text,
}) {
  return (
    <div className="filter-btn-div">
      {button ? (
        <button
          className={isLight ? "filter-btn lightBtn" : "filter-btn"}
          onClick={onClick}
          type={type ?? "button"}
        >
          {text}
        </button>
      ) : (
        <Link
          to={link ? link : "#"}
          className={isLight ? "filter-btn lightBtn" : "filter-btn"}
          onClick={handleClose ? handleClose : handleSend}
        >
          {text}
        </Link>
      )}
    </div>
  );
}

export default MainBtn;
